"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var radium_1 = require("radium");
var context_1 = require("../../context");
var components_1 = require("..");
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onKeyDown = {
            handleEvent: function (event) {
                if (event.code === 'Escape') {
                    _this.props.onClose();
                }
            },
        };
        _this.onDialogClick = function (event) {
            event.stopPropagation();
        };
        return _this;
    }
    Dialog.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.onKeyDown);
        document.documentElement.style.overflow = 'hidden';
    };
    Dialog.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.onKeyDown);
        document.documentElement.style.overflow = '';
    };
    Dialog.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, onClose = _a.onClose, title = _a.title, closeButton = _a.closeButton;
        return (React.createElement(context_1.THEME_CONTEXT.Consumer, null, function (theme) {
            var compiledStyles = styles(theme);
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { style: compiledStyles.overlay, onClick: onClose },
                    React.createElement("div", { style: compiledStyles.dialog, onClick: _this.onDialogClick },
                        React.createElement("div", { style: compiledStyles.dialog.title },
                            title,
                            React.createElement("div", { style: compiledStyles.dialog.closeArea, onClick: onClose }, closeButton || React.createElement(components_1.Button, { primary: true, text: "Close" }))),
                        React.createElement("div", { style: compiledStyles.dialog.body }, children)))));
        }));
    };
    Dialog = __decorate([
        radium_1.default
    ], Dialog);
    return Dialog;
}(React.Component));
exports.Dialog = Dialog;
var styles = function (theme) { return ({
    overlay: {
        position: 'fixed',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        background: theme.dialog.overlay.background,
        textAlign: 'center',
        zIndex: 1,
    },
    dialog: {
        margin: '50px auto 10px auto',
        display: 'inline-block',
        overflow: 'hidden',
        borderRadius: theme.dialog.content.borderRadius,
        title: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: theme.dialog.content.title.color,
            padding: theme.dialog.content.title.padding,
            background: theme.dialog.content.title.background,
            fontWeight: 'bold',
        },
        closeArea: {
            marginLeft: '2rem',
            cursor: 'pointer',
        },
        body: {
            textAlign: 'left',
            color: theme.dialog.content.body.color,
            padding: theme.dialog.content.body.padding,
            background: theme.dialog.content.body.background,
        },
    },
}); };
